import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { Card, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from 'components/DesignSystem/Button';
import Snackbar from 'components/DesignSystem/Snackbar';
import CentralizedSpinner from 'components/CentralizedSpinner';
import About from 'components/Meteorology/Agro/CultureIndex/Location/About';
import LocationCharts from 'components/Meteorology/Agro/CultureIndex/Location/LocationCharts';
import useDownloadDivImage from 'hooks/useDownloadDivImage';
import useCharts from 'hooks/Meteorology/Agro/CultureIndex/Location/useCharts';
import { store } from 'redux/store';
import {
  setGroupId,
  setLocationId,
  setCulture,
  setForecastDate,
  setPeriodStart,
  setPeriodEnd,
  setStage,
  selectMeteorologyAgroCultureIndexLocationTriggerRequest,
} from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';

export default function LocationDesktop() {
  const [showAbout, setShowAbout] = useState(false);
  const chartContainerRef = useRef<HTMLDivElement>(null);
  const filename = 'indice_por_cultura.png';
  const downloadImage = useDownloadDivImage(chartContainerRef);
  const { data, isFetching } = useCharts();
  const location = useLocation();
  const triggerRequest = useSelector(selectMeteorologyAgroCultureIndexLocationTriggerRequest);

  // Popula o Redux quando vem do clique no mapa de área
  useEffect(() => {
    const state = location.state as any;
    if (state && state.groupId && state.locationId && state.culture) {
      store.dispatch(setGroupId(state.groupId));
      store.dispatch(setLocationId(state.locationId));
      store.dispatch(setCulture(state.culture));
      store.dispatch(setForecastDate(state.forecastDate));
      store.dispatch(setPeriodStart(state.periodStart));
      store.dispatch(setPeriodEnd(state.periodEnd));
      store.dispatch(setStage(state.stage));
    }
  }, [location.state]);

  // Dispara a requisição quando triggerRequest estiver disponível e houver dados no state
  useEffect(() => {
    const state = location.state as any;
    if (triggerRequest && state && state.groupId && state.locationId && state.culture) {
      // Delay para garantir que Redux foi atualizado
      const timer = setTimeout(() => {
        triggerRequest();
      }, 200);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [triggerRequest, location.state]);

  const chartData = useMemo(() => data, [data]);

  const showWarning = !chartData;

  return (
    <>
      <About show={showAbout} onHide={() => setShowAbout(false)} />
      <Card className="shadow-sm m-5 forecast-instruction-card">
        <Col className="flex-fill p-5 h-100">
          <div className="d-flex justify-content-end mb-3">
            <Button
              id="culture-index-location-download"
              icon="download"
              type="tertiary"
              onClick={downloadImage(filename)}
              disabled={!chartData}
            />
            <Button
              id="culture-index-location-about"
              className="ms-2"
              icon="info"
              onClick={() => setShowAbout(true)}
            />
          </div>
          {isFetching && (
            <CentralizedSpinner />
          )}
          {chartData && (
            <LocationCharts
              options={chartData}
              containerRef={chartContainerRef}
            />
          )}
          {showWarning && (
            <Snackbar className="my-4 mx-4">Utilize o painel de controle para realizar uma consulta.</Snackbar>
          )}
        </Col>
      </Card>
    </>
  );
}
